<template>
  <div>
    <!-- Residence Information -->
    <h1>Residence Information</h1>

    <div class="row">
      <div class="col-12 headerUnderline">
        <img src="./assets/images/Underline.png">
      </div>
    </div>

    <div class="row">
      <FormGroup
        class="col-12"
        label="Do you own or rent your current residence?"
        :validator="$v.loan.rentorown"
      >
        <input
          id="rentorown-rent"
          v-model="model.rentorown"
          type="radio"
          value="R"
          required
        >
        <label for="rentorown-rent">Rent</label>
        <input
          id="rentorown-own"
          v-model="model.rentorown"
          type="radio"
          value="O"
          required
        >
        <label for="rentorown-own">Own</label>
      </FormGroup>
    </div>

    <div class="row">
      <div class="col-12 col-12-small">
        <h4>How long have you lived at current residence?</h4>
      </div>
    </div>

    <div class="row">
      <FormGroup
        class="col-6"
        label="Years"
        :validator="$v.loan.addressyears"
      >
        <TextInput
          v-model.number="model.addressyears"
          type="number"
          required
        />
      </FormGroup>

      <FormGroup
        class="col-6"
        label="Months"
        :validator="$v.loan.addressmonths"
      >
        <TextInput
          v-model.number="model.addressmonths"
          type="number"
          required
        />
      </FormGroup>
    </div>

    <div class="row">
      <FormGroup
        class="col-12"
        label="Driver's License State?"
        :validator="$v.loan.dlstate"
      >
        <select
          v-model="model.dlstate"
          required
        >
          <option value>
            - Select -
          </option>
          <option
            v-for="item in states"
            :key="item.id"
            :value="item.id"
          >
            {{ item.id }}
          </option>
        </select>
      </FormGroup>
    </div>

    <div class="row">
      <FormGroup
        class="col-12"
        label="Driver's License #"
        :validator="$v.loan.dlnumber"
      >
        <TextInput
          v-model="model.dlnumber"
          class="fs-exclude"
        />
      </FormGroup>
    </div>

    <div
      v-if="!status.isReturningCustomer"
      class="row"
    >
      <FormGroup
        class="col-6"
        label="Date of Birth"
        :validator="$v.loan.dob"
      >
        <DatePicker
          v-model.lazy="model.dob"
          placeholder="MM/DD/YYYY"
          required
        />
        <template #error>
          <i v-if="!$v.loan.dob.minValue">Must be 18 years or older.</i>
        </template>
      </FormGroup>

      <FormGroup
        class="col-6"
        label="Social Security #"
        :validator="$v.loan.ssn"
      >
        <TextInput
          v-model="model.ssn"
          v-inputmask="{ type: 'ssn' }"
          required
          class="fs-exclude"
        />
      </FormGroup>
    </div>

    <div class="row">
      <FormGroup
        class="col-6"
        label="Are you active military?"
        :validator="$v.loan.ismilitary"
      >
        <input
          id="ismilitary-true"
          v-model="model.ismilitary"
          type="radio"
          value="true"
          required
        >
        <label for="ismilitary-true">Yes</label>
        <input
          id="ismilitary-false"
          v-model="model.ismilitary"
          type="radio"
          value="false"
          required
        >
        <label for="ismilitary-false">No</label>
      </FormGroup>

      <FormGroup
        class="col-6"
        label="Are you a U.S. citizen?"
        :validator="$v.loan.iscitizen"
      >
        <input
          id="iscitizen-true"
          v-model="model.iscitizen"
          type="radio"
          value="true"
          required
        >
        <label for="iscitizen-true">Yes</label>
        <input
          id="iscitizen-false"
          v-model="model.iscitizen"
          type="radio"
          value="false"
          required
        >
        <label for="iscitizen-false">No</label>
      </FormGroup>
    </div>
    <!-- ./ Residence Information -->

    <!-- Employee Information -->
    <h1 class="mt-l">
      Employee Information
    </h1>

    <div class="row">
      <div class="col-12 headerUnderline">
        <img src="./assets/images/Underline.png">
      </div>
    </div>

    <div class="row">
      <FormGroup
        class="col-12"
        label="Date Hired at Current Job"
        :validator="$v.loan.hiredate"
      >
        <DatePicker
          v-model.lazy="model.hiredate"
          placeholder="MM/DD/YYYY"
          required
        />
        <template #error>
          <i v-if="!$v.loan.hiredate.minValue">Employment length should be greater than 60 days.</i>
        </template>
      </FormGroup>
    </div>

    <div class="row">
      <FormGroup
        class="col-12"
        label="Employer Name"
        :validator="$v.loan.empname"
      >
        <TextInput v-model.number="model.empname" />
      </FormGroup>
    </div>

    <div class="row">
      <FormGroup
        class="col-12"
        label="Employer State"
        :validator="$v.loan.empstate"
      >
        <select
          v-model="model.empstate"
          required
        >
          <option value>
            - Select -
          </option>
          <option
            v-for="item in states"
            :key="item.id"
            :value="item.id"
          >
            {{ item.id }}
          </option>
        </select>
      </FormGroup>
    </div>

    <div class="row">
      <FormGroup
        class="col-12"
        label="Employer Zip Code"
        :validator="$v.loan.empzip"
      >
        <TextInput
          v-model="model.empzip"
          v-inputmask="{ type: 'zip' }"
          required
        />
      </FormGroup>
    </div>

    <div class="row">
      <FormGroup
        class="col-12"
        label="Employer Phone Number"
        :validator="$v.loan.empphone"
      >
        <TextInput
          v-model="model.empphone"
          v-inputmask="{ type: 'us-phone' }"
          required
        />
      </FormGroup>
    </div>
    <!-- Employee Information -->

    <div class="row mt-l">
      <div class="col-6 col-12-medium">
        <ul class="actions fit">
          <li>
            <button
              class="button primary fit icon fa-lock"
              @click="handleNext()"
            >
              CLICK TO CONTINUE
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import jsonStates from "@/config/states.json";
import validations from "../validations";

export default {
  name: "StepTwo",
  data() {
    return {
      states: jsonStates,
      model: {},
      stepFields: [
        "rentorown",
        "addressyears",
        "addressmonths",
        "dlstate",
        "dlnumber",
        "dob",
        "ssn",
        "ismilitary",
        "iscitizen",
        "ismilitary",
        "hiredate",
        "empname",
        "empphone",
        "empstate",
        "empzip"
      ],
    };
  },

  computed: {
    ...mapState("underwriting", ["status", "loan"]),
  },

  mounted() {
    this.model = this.loan;
  },

  validations() {
    return {
      loan: validations,
    };
  },

  methods: {
    ...mapActions("underwriting", ["updateLoan"]),
    handleNext() {
      let isValid = true;
      this.updateLoan({ ...this.model });
      this.stepFields.forEach((field) => {
        if (this.$v.loan[field]) {
          this.$v.loan[field].$touch();
          isValid = isValid && !this.$v.loan[field].$anyError;
        }
      });

      if (isValid) {
        this.$router.push("/step-3");
      } else {
        this.$nextTick(() => {
          this.scroll(true);
        });
      }
    },

    scroll(toError = false) {
      let top = 0;

      if (toError) {
        const domRect = document
          .querySelector(".with-errors")
          .getBoundingClientRect();
        top = domRect.top + document.documentElement.scrollTop - 230;
      }

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    },
  }
};
</script>
